/* eslint-disable react/prop-types,react/jsx-filename-extension */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import locales from 'locales';

const TranslateProperty = ({ user, properties, children }) => {
  const translatedProps = {};
  properties.forEach((property) => {
    translatedProps[property.key] = locales[user.language][property.value];
  });
  const cloned = React.cloneElement(children, translatedProps);
  return (
    <Fragment>
      {cloned}
    </Fragment>
  );
};

TranslateProperty.propTypes = {
  user: PropTypes.object.isRequired,
  properties: PropTypes.array.isRequired,
};

const mapSateToProps = state => ({
  user: state.user,
});

export default connect(mapSateToProps)(TranslateProperty);



// WEBPACK FOOTER //
// ./src/components/TranslateProperty.jsx